import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_SAP_AI_IMAGE_PROMPT = defineFcm('sap_ai_image_prompt')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				isEnabled: { type: 'boolean' },
				systemPrompt: { type: 'string' },
				mainPrompt: {
					type: 'object',
					shape: {
						replacements: { type: 'array', shape: { type: 'string' } },
						text: { type: 'string' },
					},
				},
				options: {
					type: 'object',
					optional: true,
					shape: {
						conversationsModel: { type: 'string', optional: true },
						imageModel: { type: 'string', optional: true },
						imageSize: { type: 'string', optional: true },
					},
				},
			},
		}),
	)
	.withDefault({
		isEnabled: false,
		systemPrompt: '',
		mainPrompt: { text: '', replacements: [] },
		options: undefined,
	})
	.toConfig({
		owner: 'squad-starfish',
		scope: ['corgi-front-end', 'corgi-middle-end'],
		context: 'Start A Petition Page - Media Step',
		description:
			'Configuration for SAP AI Image Prompt step: isEnabled determines whether the AI Image generation is enabled for users. If it is enabled, systemPrompt specifies system prompt sent to ChatGPT and mainPrompt is the user prompt. Replacements are string replacements in the main prompt. The options provide overrides for the conversations and image API calls.',
		template: {
			isEnabled: true,
			systemPrompt:
				'You work for Change.org. Your role is to write a prompt for an AI to create the best possible image possible for a given petition. You only return the prompt and nothing else. The prompt should be clear that there should be no text on the image. The prompt should ensure that the image will not have too many elements and be very easy to read and understand for viewers.',
			mainPrompt: {
				replacements: ['petitionTitle', 'petitionContent'],
				text: 'This is the petition title: %{petitionTitle}. Here is the petition content: %{petitionContent}.',
			},
			options: {
				conversationsModel: 'gpt-4',
				imageModel: '"dall-e-3"',
				imageSize: '1024x1024',
			},
		},
	});
